
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.173 10.836c.919 0 1.666-.747 1.666-1.666 0-.92-.747-1.667-1.666-1.667-.92 0-1.667.748-1.667 1.667 0 .92.747 1.666 1.667 1.666z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M22.543 5.003H7.673c-1.422 0-2.667 1.151-2.667 2.464v10.178a.626.626 0 000 .167v.654a2.465 2.465 0 002.462 2.464h.802v3.24a.833.833 0 001.438.573l3.62-3.814h9.216a2.465 2.465 0 002.462-2.463v-11a2.466 2.466 0 00-2.463-2.463zM7.673 6.67h14.87c.438 0 .796.357.796.797v6.653l-4.383-4.383c-.55-.55-1.517-.55-2.067 0l-3.967 3.967-1.05-1.05c-.55-.552-1.516-.552-2.066 0l-3.134 3.133v-8.32c0-.388.514-.797 1-.797z","fill":"#525F7F"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(5 5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    